<template>
  <div>
    <section id="page-title">
            <div class="container clearfix">
                <h1 data-animate="fadeInUp">2013 Summer</h1>
                <span data-delay="300" data-animate="fadeInUp">Summer show</span>
            </div>
        </section>
         <section id="content">
            <div class="content-wrap">
                <div class="container clearfix">
                    <!-- Portfolio Filter
============================================= -->
                    <!-- #portfolio-filter end -->
                    <div class="clear"></div>
                    <!-- Portfolio Items
============================================= -->
                    <!--June 2013-->
                    <article class="portfolio-item june2013">
                        <div class="portfolio-image">
                            <div class="fslider" data-arrows="false" data-speed="400" data-pause="4000">
                                <div class="flexslider">
                                    <div class="slider-wrap">
                                        <div class="slide">
                                            <a href="#"><img src="/assets/img/june2013/thumbs/1june2013.jpg" alt="June 2013 IDS" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="portfolio-overlay">
                                <a href="/assets/img/june2013/1june2013.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                            </div>
                        </div>
                    </article>
                    <article class="portfolio-item june2013">
                        <div class="portfolio-image">
                            <div class="fslider" data-arrows="false" data-speed="400" data-pause="4000">
                                <div class="flexslider">
                                    <div class="slider-wrap">
                                        <div class="slide">
                                            <a href="#"><img src="/assets/img/june2013/thumbs/2june2013.jpg" alt="June 2013 IDS" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="portfolio-overlay">
                                <a href="/assets/img/june2013/2june2013.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                            </div>
                        </div>
                    </article>
                    <article class="portfolio-item june2013">
                        <div class="portfolio-image">
                            <div class="fslider" data-arrows="false" data-speed="400" data-pause="4000">
                                <div class="flexslider">
                                    <div class="slider-wrap">
                                        <div class="slide">
                                            <a href="#"><img src="/assets/img/june2013/thumbs/4june2013.jpg" alt="June 2013 IDS" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="portfolio-overlay">
                                <a href="/assets/img/june2013/4june2013.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                            </div>
                        </div>
                    </article>
                    <article class="portfolio-item june2013">
                        <div class="portfolio-image">
                            <div class="fslider" data-arrows="false" data-speed="400" data-pause="4000">
                                <div class="flexslider">
                                    <div class="slider-wrap">
                                        <div class="slide">
                                            <a href="#"><img src="/assets/img/june2013/thumbs/5june2013.jpg" alt="June 2013 IDS" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="portfolio-overlay">
                                <a href="/assets/img/june2013/5june2013.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                            </div>
                        </div>
                    </article>
                    <article class="portfolio-item june2013">
                        <div class="portfolio-image">
                            <div class="fslider" data-arrows="false" data-speed="400" data-pause="4000">
                                <div class="flexslider">
                                    <div class="slider-wrap">
                                        <div class="slide">
                                            <a href="#"><img src="/assets/img/june2013/thumbs/6june2013.jpg" alt="June 2013 IDS" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="portfolio-overlay">
                                <a href="/assets/img/june2013/6june2013.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                            </div>
                        </div>
                    </article>
                    <article class="portfolio-item june2013">
                        <div class="portfolio-image">
                            <div class="fslider" data-arrows="false" data-speed="400" data-pause="4000">
                                <div class="flexslider">
                                    <div class="slider-wrap">
                                        <div class="slide">
                                            <a href="#"><img src="/assets/img/june2013/thumbs/7june2013.jpg" alt="June 2013 IDS" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="portfolio-overlay">
                                <a href="/assets/img/june2013/7june2013.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                            </div>
                        </div>
                    </article>
                    <article class="portfolio-item june2013">
                        <div class="portfolio-image">
                            <div class="fslider" data-arrows="false" data-speed="400" data-pause="4000">
                                <div class="flexslider">
                                    <div class="slider-wrap">
                                        <div class="slide">
                                            <a href="#"><img src="/assets/img/june2013/thumbs/8june2013.jpg" alt="June 2013 IDS" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="portfolio-overlay">
                                <a href="/assets/img/june2013/8june2013.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                            </div>
                        </div>
                    </article>
                    <article class="portfolio-item june2013">
                        <div class="portfolio-image">
                            <div class="fslider" data-arrows="false" data-speed="400" data-pause="4000">
                                <div class="flexslider">
                                    <div class="slider-wrap">
                                        <div class="slide">
                                            <a href="#"><img src="/assets/img/june2013/thumbs/9june2013.jpg" alt="June 2013 IDS" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="portfolio-overlay">
                                <a href="/assets/img/june2013/9june2013.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                            </div>
                        </div>
                    </article>
                    <article class="portfolio-item june2013">
                        <div class="portfolio-image">
                            <div class="fslider" data-arrows="false" data-speed="400" data-pause="4000">
                                <div class="flexslider">
                                    <div class="slider-wrap">
                                        <div class="slide">
                                            <a href="#"><img src="/assets/img/june2013/thumbs/10june2013.jpg" alt="June 2013 IDS" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="portfolio-overlay">
                                <a href="/assets/img/june2013/10june2013.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                            </div>
                        </div>
                    </article>
                    <article class="portfolio-item june2013">
                        <div class="portfolio-image">
                            <div class="fslider" data-arrows="false" data-speed="400" data-pause="4000">
                                <div class="flexslider">
                                    <div class="slider-wrap">
                                        <div class="slide">
                                            <a href="#"><img src="/assets/img/june2013/thumbs/11june2013.jpg" alt="June 2013 IDS" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="portfolio-overlay">
                                <a href="/assets/img/june2013/11june2013.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                            </div>
                        </div>
                    </article>
                    <article class="portfolio-item june2013">
                        <div class="portfolio-image">
                            <div class="fslider" data-arrows="false" data-speed="400" data-pause="4000">
                                <div class="flexslider">
                                    <div class="slider-wrap">
                                        <div class="slide">
                                            <a href="#"><img src="/assets/img/june2013/thumbs/12june2013.jpg" alt="June 2013 IDS" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="portfolio-overlay">
                                <a href="/assets/img/june2013/12june2013.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                            </div>
                        </div>
                    </article>
                    <article class="portfolio-item june2013">
                        <div class="portfolio-image">
                            <div class="fslider" data-arrows="false" data-speed="400" data-pause="4000">
                                <div class="flexslider">
                                    <div class="slider-wrap">
                                        <div class="slide">
                                            <a href="#"><img src="/assets/img/june2013/thumbs/13june2013.jpg" alt="June 2013 IDS" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="portfolio-overlay">
                                <a href="/assets/img/june2013/13june2013.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                            </div>
                        </div>
                    </article>
                    <article class="portfolio-item june2013">
                        <div class="portfolio-image">
                            <div class="fslider" data-arrows="false" data-speed="400" data-pause="4000">
                                <div class="flexslider">
                                    <div class="slider-wrap">
                                        <div class="slide">
                                            <a href="#"><img src="/assets/img/june2013/thumbs/14june2013.jpg" alt="June 2013 IDS" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="portfolio-overlay">
                                <a href="/assets/img/june2013/14june2013.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                            </div>
                        </div>
                    </article>
                </div>
                <!-- #portfolio end -->
                <!-- Portfolio Script
============================================= -->
                <!--<script type="text/javascript">
                    jQuery(window).load(function() {

                        var $container = $('#portfolio');

                        $container.isotope({
                            transitionDuration: '0.65s'
                        });

                        $('#portfolio-filter a').click(function() {
                            $('#portfolio-filter li').removeClass('activeFilter');
                            $(this).parent('li').addClass('activeFilter');
                            var selector = $(this).attr('data-filter');
                            $container.isotope({
                                filter: selector
                            });
                            return false;
                        });

                        $('#portfolio-shuffle').click(function() {
                            $container.isotope('updateSortData').isotope({
                                sortBy: 'random'
                            });
                        });

                        $(window).resize(function() {
                            $container.isotope('layout');
                        });

                    });
                </script> -->
                <!-- Portfolio Script End -->
            </div>

        </section>
  </div>
</template>
<script>
  export default {
    name: "2013spring",
    components: {

    },
    beforeMount(){
    jQuery(window).load(function() {

        var $container = jQuery('#portfolio');

        $container.isotope({
            transitionDuration: '0.65s'
        });

        jQuery('#portfolio-filter a').click(function() {
            jQuery('#portfolio-filter li').removeClass('activeFilter');
            jQuery(this).parent('li').addClass('activeFilter');
            var selector = $(this).attr('data-filter');
            $container.isotope({
                filter: selector
            });
            return false;
        });

        jQuery('#portfolio-shuffle').click(function() {
            $container.isotope('updateSortData').isotope({
                sortBy: 'random'
            });
        });

        jQuery(window).resize(function() {
            $container.isotope('layout');
        });

    });
    }
  }
</script>
